{
  "GOOGLE": "Sign in with Google",
  "FACEBOOK": "Sign in with Facebook",
  "LINKEDIN": "Sign in with LinkedIn",
  "google": "Continue with Google",
  "FACEBOOK_LOGIN": "Continue with Facebook",
  "LINKEDIN_LOGIN": "Continue with LinkedIn",
  "Email": "Continue with Email",
  "COMPLETED": "Completed",
  "DECLINED": "Declined",
  "EXPIRED": "Expired",
  "IN_PROGRESS": "In Progress",
  "SIGNED": "Signed",
  "REJECTED": "Rejected",
  "DONE": "Done",
  "CANCELLED": "Cancelled",
  "COPIED": "Text copied successfully",
  "FAILED_TO_COPIED": "Failed to copy text",
  "DISCARD": "Discard",
  "BRANDING": "Branding",
  "SOON": "Soon",
  "PREVIEW": "Preview",
  "TITLE": "Title",
  "FULL_NAME": "Full name",
  "PHONE": "Phone Number",
  "PREFERRED_LANGUAGE": "System Language",
  "SEARCH": "Search",
  "SELECT": "Select",
  "UPGRADE": "Upgrade",
  "CONTACT_US": "Contact us",
  "SIGNATURES": "Signatures",
  "PHONE_NUMBER": "Phone number",
  "COUNTRY_CODE": "Country code",
  "SELECTED": "Selected",
  "UPDATE": "Save changes",
  "ACTIVE": "Active",
  "PENDING": "Pending",
  "MONTH": "Month",
  "YEAR": "Year",
  "OPEN_DROPDOWN_MENU": "Open dropdown menu",
  "UNDO_CHANGES": "Undo Changes",
  "DISMISS": "Dismiss",
  "DATE": "Date",
  "DESCRIPTION": "Description",
  "ENGLISH": "English",
  "ARABIC": "Arabic",
  "FRENCH": "French",
  "DANISH": "Danish",
  "GENERAL": {
    "SERVICE_IN_MAINTENANCE": "Service in maintenance",
    "CANCEL": "Cancel",
    "EMAIL_ADDRESS": "Email Address",
    "EMAIL": "Email",
    "VOILA": "Voilà",
    "NO_CANCEL": "No, Cancel",
    "YES_DELETE": "Yes, delete",
    "CONFIRM": "Yes, I'm sure",
    "CONTINUE": "Continue",
    "BACK": "Back",
    "ERROR_MESSAGES": {
      "SOMETHING_WENT_WRONG": "Something went wrong. Please try again later!",
      "NOT_FOUND": "Whoops!!! Page Not Found!",
      "SERVER_ERROR": "Internal Server Error",
      "UNAUTHORIZED": "Unauthorized"
    }
  },
  "LANGUAGES": {
    "ENGLISH": "English",
    "DANISH": "Danish",
    "ARABIC": "Arabic",
    "FRENCH": "French"
  },
  "ORDER_STATUS_ICON": "order status icon",
  "ORDER_ACTION_MENU": "order action menu",
  "ORDER-STATISTICS": {
    "ALL-ORDER": "All Orders",
    "ACTIVE-ORDERS": "In Progress",
    "COMPLETED-ORDERS": "Completed",
    "CLOSED-ORDERS": "Closed"
  },
  "ORDER-DETAILS": {
    "ORDER-CANCELLED": {
      "SUCCESS": "Order cancelled successfully",
      "ERROR": "Failed to cancel order"
    },
    "ORDER-TITLE": "Order Title",
    "RECIPIENTS": "Recipients",
    "STATUS": "Status",
    "SIGNING_STATUS": "Signing Status",
    "LAST-CHANGE": "Activity",
    "EXPIRING-DATE": "Expiring Date",
    "ACTIONS": "Actions",
    "ORDER-OPTIONS": {
      "SEND-REMINDER": "Send Reminder",
      "ORDER-ACTIVITY": "Order Activity",
      "ORDER-DETAILS": "Order Details",
      "CANCEL-ORDER": "Cancel Order"
    },
    "CANCEL-ORDER-MODAL": {
      "TITLE": "Cancel this signing order?",
      "SUBTITLE": "This will notify all recipients.",
      "DESCRIPTION": "All recipients will be notified and can no longer sign. This action can't be undone.",
      "CALLOUT": "Once cancelled, this document cannot be reactivated.",
      "KEEP-ORDER": "No, keep order",
      "CANCEL-ORDER": "Cancel order"
    },
    "ORDER": "Order",
    "TO": "To",
    "BY": "by",
    "AT": "at",
    "MORE": "more",
    "DONE": "done",
    "ORDER-STATUS": "Order Status",
    "SENT": "Sent",
    "EXPIRES": "Expires",
    "SIGNED-BY": "Signed by",
    "OF": "of",
    "SIGNERS": "Signers",
    "ORDER-ID": "Order ID",
    "DAYS-REMAINING": "days remaining",
    "COMPLETION": "Completion",
    "ATTACHMENTS": "Attachments",
    "UPLOADED-BY": "Uploaded by",
    "SIGNED-ON": "Signed on",
    "REJECTED-ON": "Rejected on",
    "AUDIT-MOCK": "IP: — · OS: — · Browser: —",
    "ACTIVITY-LOG": "Activity Log",
    "RECEIVERS": "Receivers",
    "REVIEWED-BY": "Reviewed by",
    "REVIEWERS": "Reviewers",
    "DOCUMENTS": "documents",
    "NO-SIGNERS": "No signers",
    "NO-RECEIVERS": "No receivers",
    "NO-REVIEWERS": "No reviewers",
    "REMINDER-SENT": "Reminder sent",
    "RESEND-REMINDER": "Resend Reminder",
    "CREATED-BY": "Created by"
  },
  "PAGINATION": {
    "PREVIOUS": "Previous",
    "NEXT": "Next",
    "PER_PAGE": "Per page",
    "SHOWING_RESULTS": "Showing {{from}}-{{to}} of {{totalLength}} results"
  },
  "LANG": "English",
  "PROCESSING": "processing...",
  "SAVE": "Save",
  "SAVE_DISCOUNT": "Save",
  "SEND_ORDER": "Send Order",
  "DAY": "day",
  "DAYS": "days",
  "REVIEWER": "Needs to review",
  "SIGNER": "Needs to sign",
  "COPIER": "Receive a copy",
  "SIDE_BAR": {
    "SIGNING": "Signing Orders",
    "SETTINGS": "Settings",
    "FAQ": "FAQs",
    "FORMS": "Forms",
    "LOG_OUT": "Logout",
    "PROFILE": "Profile"
  },
  "HEADER": {
    "CREATE_ORDER": "Create Order",
    "MANAGE_ORDER": "Signing Orders"
  },
  "CONTRACT_ORDER": {
    "RECIPIENT_INFORMATION": "Recipient Information",
    "ORDER_SETTINGS": "Order Settings",
    "ORDER_MESSAGE": "Order Message",
    "NEW_SIGNING_ORDER": "New signing order",
    "ORDER_TITLE": "Order title",
    "REMIND_SIGNERS": "Remind signers every",
    "EMAIL_SUBJECT": "Email Subject",
    "EMAIL_SUBJECT_PLACEHOLDER": "[Sender name] sent you documents to sign",
    "EMAIL_BODY": "Message",
    "EMAIL_BODY_PLACEHOLDER": "Add a short message for your recipients (optional). It appears in the email with the signing link",
    "NAME": "Name",
    "EMAIL": "Email",
    "PHONE_NUMBER": "Phone number",
    "TASK": "Task",
    "ADD_RECIPIENT": "Add Recipient",
    "ACTIONS": "Actions",
    "PRIORITY": "Priority",
    "MESSAGE-ALL": "Message for all",
    "SELECT-TASK": "Select a task",
    "SELECT-PRIORITY": "Select a priority",
    "ENTER-EMAIL": "Enter email address",
    "ENTER-NAME": "Enter your name",
    "ENTER-PHONE": "Enter phone number",
    "MOVE_DOWN": "Move down",
    "MOVE_UP": "Move up",
    "DELETE": "Delete",
    "RECEIVE": "Receive",
    "ROLE": "Role",
    "REVIEW_DOCUMENT": "Review document",
    "SIGN_DOCUMENT": "Sign document",
    "MOVE_TO": "Move to",
    "NO_RECIPIENTS": "No recipients added yet",
    "RECEIVE_NEXT": "Receive next",
    "REMIND_PERIOD": "Remind Recipient Every",
    "EXPIRATION_PERIOD": "Expiration Period",
    "LOGIN_TO_VIEW_DOCUMENTS": "Login required to view documents",
    "RECEIVE_COPY": "Receive a copy",
    "NEXT": "Next",
    "SEND_ORDER": "Send order",
    "SIGNING_METHOD": "Signing Method (optional)",
    "REMINDERS_SENT_SUCCESSFULLY": "Reminders sent successfully",
    "ORDER_WAS_CANCELLED_OR_DECLINED": "Order was cancelled or declined!",
    "OUT_OF_SIGNATURES_WARNING": "No signatures remaining.",
    "EXTRA_SIGNATURES_ARE_NEEDED": "This order may not be completed due to insufficient signatures",
    "CANT_ADD_RECIPIENTS": "You can't add more recipients due to insufficient signatures",
    "VERIFICATION_METHOD": "Verification Method",
    "WHATSAPP": "Whatsapp",
    "DISCARD_ORDER_TITLE": "Discard this signing order?",
    "DISCARD_ORDER_SUBTITLE": "This action cannot be undone.",
    "DISCARD_ORDER_DESCRIPTION": "Your uploaded documents and recipient details will be permanently deleted.",
    "KEEP_EDITING": "Keep editing",
    "DISCARD_ORDER": "Discard order",
    "NOT_SPECIFIED": "Not specified",
    "NEW_SIGNING_ORDER_SUBTITLE": "Add your documents, choose who signs and in what order, then send.",
    "ORDER_LANGUAGE": "Order Language",
    "RECIPIENT_DETAILS": "Recipient details",
    "RECEIVER_DETAILS": "Receiver details",
    "NO_RECEIVERS_YET": "No receiver added yet",
    "ADD_RECEIVER": "Add Receiver",
    "RECIPIENTS_LABEL": "recipients",
    "RECEIVERS_LABEL": "receivers",
    "ORDINAL_RECIPIENTS": [
      "Receives first",
      "Receives second",
      "Receives third",
      "Receives fourth",
      "Receives fifth",
      "Receives sixth",
      "Receives seventh",
      "Receives eighth",
      "Receives ninth",
      "Receives tenth"
    ]
  },
  "SETTINGS": {
    "NAME": "Settings",
    "ACCOUNT_INFO": "Account Info",
    "CHANGE_PASSWORD": "Change Password",
    "CHANGE_PASSWORD_EMAIL_SENT": "Password reset email has been sent to your inbox",
    "CHANGE_PASSWORD_EMAIL_FAILED": "Failed to send password reset email, please try again",
    "TEAM_MANAGEMENT": "User Management",
    "TEAM_MANAGEMENT_DESCRIPTION": "Manage teammates and their access permissions.",
    "ORDER_SETTINGS": "Order Settings",
    "FIRST_NAME": "First Name",
    "LAST_NAME": "Last Name",
    "ROLE": "Role",
    "INVITATION_STATUS": "Status",
    "INVITE_SUCCESS": "User invited successfully",
    "INVITE_ERROR": "Error while inviting user",
    "INVITE_MEMBERS_ERROR": "Could not send invitations. Try again from Settings.",
    "SEND_INVITATION": "Send Invitation",
    "MANAGE_SUBSCRIPTION": "Subscription Management",
    "SUBSCRIPTIONS": "Subscriptions",
    "CHANGE_PLAN": "Edit Subscription Plan",
    "MANAGE_PAYMENTS": "Manage Payments",
    "CHANGE_PLAN_QUESTION": "Change plan?",
    "CANCEL_SUBSCRIPTION": "Cancel subscription",
    "DELETE_TEAM_MEMBER": "Delete Team Member",
    "DELETE_TEAM_MEMBER_DESCRIPTION": "You are about to remove \"<span class=’font-bold’>{{name}}</span>\" from the team. Their <span class=’font-bold’>{{ordersCount}}</span> active orders will be reassigned to another member.",
    "DELETE_TEAM_MEMBER_DESCRIPTION_NO_NAME": "You are about to remove \"<span class=’font-bold’>{{email}}</span>\" from the team. Their <span class=’font-bold’>{{ordersCount}}</span> active orders will be reassigned to another member.",
    "PLAN_NAME": "<span class='font-bold'>Plan:</span> <span class='font-medium'>{{planName}}</span>",
    "SUBSCRIPTION_MANAGEMENT": "Subscription",
    "SUBSCRIPTION_MANAGEMENT_DESCRIPTION": "Monitor your usage and manage your subscription plan details.",
    "TRANSACTION_HISTORY": "Billing History",
    "SIGNATURES_USED_OF": "of {{signatures}} signatures used",
    "SIGNATURES_USED_TOTAL": "{{used}} of {{total}} used",
    "SIGNATURE_USAGE": "Signature usage",
    "AUTO_RENEWAL": "Auto-renewal",
    "SUBSCRIPTIONS_TITLE": "Add more signatures",
    "DELETE_TEAM_MEMBER_DESCRIPTION_NO_ORDER": "You are about to remove \"<span class=’font-bold’>{{name}}</span>\" from the team.",
    "DELETE_TEAM_MEMBER_DESCRIPTION_NO_ORDER_NO_NAME": "You are about to remove \"<span class=’font-bold’>{{email}}</span>\" from the team.",
    "REASSIGN_BEFORE_REMOVING": "Reassign their work before removing.",
    "REASSIGN_ORDERS_TO": "Reassign orders to",
    "INVITE_TEAM_MEMBER": "Add Teammate",
    "INVITE_TEAM_MEMBER_TITLE": "Invite team member",
    "INVITE_TEAM_MEMBER_SUBTITLE": "Add a new member to your workspace.",
    "MEMBER_INVITATION_NOTE": "Each member will receive an invitation email to create their account.",
    "ACCEPT_TERMS_AND_CONDITIONS": "I accept Terms of Services and Privacy Policy",
    "USER_DELETED_SUCCESSFULLY": "User deleted successfully",
    "FAILED_TO_DELETE_USER": "Failed to delete user",
    "ACCOUNT_SETTINGS_UPDATED_SUCCESSFULLY": "Account settings updated successfully",
    "FAILED_TO_UPDATE_ACCOUNT_SETTINGS": "Failed to update account settings",
    "PUBLIC_PROFILE": "Account",
    "PUBLIC_PROFILE_SUBTITLE": "Your personal details, language and password.",
    "PROFILE_PICTURE": "Profile Picture",
    "UPLOAD_NEW_PHOTO": "Upload new photo",
    "PHOTO_HINT": "JPG or PNG. Max size of {{maxSizeMb}}MB",
    "PREFERENCES": "Preferences",
    "PREFERENCES_SUBTITLE": "Choose the language JunoSign appears in.",
    "ACCOUNT_SECURITY": "Account Security",
    "ACCOUNT_SECURITY_SUBTITLE": "Manage your password and authentication settings.",
    "CHOOSE_A_PLAN": "Upgrade your plan for new business needs.",
    "CHOOSE_A_PLAN_DESCRIPTION": "Here at JunoSign we focus on markets where technology, innovation, and capital can unlock long-term value and drive economic growth.",
    "PER_USER_MONTHLY": "Per user/month",
    "PER_USER_YEARLY": "Per user/year",
    "CHANGE_PLAN_CONFIRMATION": "Are you sure you want to change your plan to {{planName}}/{{period}}?",
    "CHANGE_PLAN_SUCCESS_MESSAGE": "Plan is scheduled to change on the next billing date",
    "SCHEDULED_PLAN_MESSAGE": "Your plan changes to <span class='font-bold'>{{planName}} Plan</span> on {{date}}",
    "SCHEDULED_CHANGES_CANCEL_SUCCESS": "Your scheduled plan changes have been cancelled",
    "CANCEL_SUBSCRIPTION_CHANGES": "Cancel Subscription Changes",
    "CANCEL_SUBSCRIPTION_CHANGES_SUBTITLE": "Revert to your current plan settings",
    "CANCEL_SUBSCRIPTION_CHANGES_DESCRIPTION": "Canceling your subscription changes to {{planName}} Plan?",
    "CANCEL_SUBSCRIPTION_CHANGES_SECONDARY_DESCRIPTION": "Your current plan will remain active.",
    "CANCEL_SUBSCRIPTION_SUBTITLE": "This action cannot be undone.",
    "CANCEL_SUBSCRIPTION_CONFIRMATION": "Canceling your subscription will remove your access, and you won’t be charged in the next billing cycle.",
    "CANCEL_SUBSCRIPTION_CONFIRMATION_END_DATE": "Your current subscription will remain active until {{endDate}}.",
    "CANCEL_SUBSCRIPTION_SUCCESS": "Your subscription has been scheduled for cancellation",
    "CANCEL_SUBSCRIPTION_MESSAGE": "Your plan is scheduled to be cancelled on {{date}}",
    "REMOVE_CANCELLATION": "Remove Cancellation",
    "REMOVE_CANCELLATION_SUBTITLE": "Your subscription will stay active.",
    "REMOVE_CANCELLATION_DESCRIPTION": "Remove cancellation of your subscription?",
    "REMOVE_CANCELLATION_BILLING_DATE": "Your subscription will stay active and you will be charged on {{date}}",
    "REMOVE_CANCELLATION_SUCCESS": "Your scheduled subscription cancellation has been removed",
    "ROLE_UPDATED_SUCCESSFULLY": "User role updated successfully",
    "API_SETTINGS": {
      "TITLE": "API Settings",
      "DESCRIPTION": "Generate API keys and manage credentials to integrate with external systems securely.",
      "EMPTY_TITLE": "No API Keys Yet",
      "EMPTY_DESCRIPTION": "Create your first API key to integrate with external services and automate your signing flow.",
      "CREATE_API_KEY": "Create API Key",
      "CREATE_MODAL_SUBTITLE": "Generate a new API key for your workspace.",
      "EDIT_API_KEY": "Edit API Key",
      "EDIT_MODAL_SUBTITLE": "Update the name and permissions of your API key.",
      "KEY_NAME": "Key Name",
      "KEY_NAME_HINT": "Default name is your workspace name",
      "EXPIRATION_DATE": "Expiration Date",
      "EXPIRATION_DAYS": "{{days}} Days",
      "PERMISSIONS": "Permissions",
      "PERMISSION": {
        "CREATE": "Create",
        "READ": "Read",
        "UPDATE": "Update",
        "DELETE": "Delete"
      },
      "PERMISSION_REQUIRED": "Select at least one permission.",
      "CREATE": "Create",
      "SAVE": "Save",
      "DONE": "Done",
      "COPY": "Copy {{field}}",
      "CREATED_TITLE": "API Key Created Successfully",
      "CREATED_SUBTITLE": "Your new credentials are ready to use.",
      "ROTATED_TITLE": "API Key Rotated Successfully",
      "ROTATED_SUBTITLE": "Your new credentials are ready to use.",
      "CLIENT_ID": "Client ID",
      "SECRET_KEY": "Secret Key",
      "SAVE_SECRET_WARNING": "Save your Secret Key now. You won't be able to see it again.",
      "STATUS": {
        "ACTIVE": "Active",
        "DISABLED": "Disabled"
      },
      "CREATED": "Created",
      "LAST_USED": "Last Used",
      "NEVER_USED": "Never",
      "DATE_AT_TIME": "{{date}} at {{time}}",
      "EXPIRES_ON": "{{date}} ({{days}} Days)",
      "DISABLE": "Disable",
      "ENABLE": "Enable",
      "ROTATE": "Rotate",
      "MENU": {
        "ROTATE": "Rotate API Key",
        "EDIT": "Edit API Key",
        "DELETE": "Delete Key"
      },
      "DISABLED_BANNER": "This API key is currently disabled. Enable it to restore access.",
      "ROTATE_MODAL": {
        "TITLE": "Rotate API Key",
        "SUBTITLE": "This will revoke your current key.",
        "MESSAGE": "This will generate a new Secret Key with the same permissions. The current key will be immediately revoked and any integrations using it will stop working.",
        "CALLOUT": "Key rotation is permanent. Save your new key now.",
        "CONFIRM": "Rotate Key"
      },
      "DISABLE_MODAL": {
        "TITLE": "Disable API Key",
        "SUBTITLE": "This key will stop working immediately.",
        "MESSAGE": "All integrations using this key will immediately lose access to the API and stop functioning. You can re-enable this key at any point to restore access.",
        "CALLOUT": "You can re-enable this key at any time.",
        "CONFIRM": "Disable Key"
      },
      "ACTIVATE_MODAL": {
        "TITLE": "Activate API Key",
        "SUBTITLE": "This key will start working immediately.",
        "MESSAGE": "All integrations configured with this key will regain access to the API. Make sure your services are ready to handle requests.",
        "CALLOUT": "Once activated, this key will be live immediately.",
        "CONFIRM": "Activate Key"
      },
      "DELETE_MODAL": {
        "TITLE": "Delete API Key",
        "SUBTITLE": "This action cannot be undone.",
        "MESSAGE": "The selected API key and all associated permissions will be permanently removed. Any active integrations or services depending on this key will instantly fail.",
        "CALLOUT": "This is irreversible. Ensure no services depend on this key.",
        "CONFIRM": "Delete Key"
      },
      "UPDATED_SUCCESSFULLY": "API key updated successfully",
      "DISABLED_SUCCESSFULLY": "API key disabled successfully",
      "ENABLED_SUCCESSFULLY": "API key activated successfully",
      "DELETED_SUCCESSFULLY": "API key deleted successfully",
      "SCOPES": "Scopes",
      "SCOPE": {
        "ORDERS_READ": "Read",
        "ORDERS_CREATE": "Create",
        "ORDERS_CANCEL": "Delete",
        "WEBHOOKS_MANAGE": "Webhooks Permission"
      },
      "EXPIRY": {
        "ONE_MONTH": "30 Days",
        "THREE_MONTHS": "90 Days",
        "SIX_MONTHS": "180 Days",
        "ONE_YEAR": "1 Year"
      }
    }
  },
  "TRANSACTION_HISTORY": {
    "PAYMENT_ID": "Transaction ID",
    "TRANSACTION_DATE": "Date",
    "DOWNLOAD_INVOICE": "Download",
    "NO_HISTORY": "No billing history yet",
    "NO_HISTORY_DESCRIPTION": "Your billing transactions and invoices will appear here once you make your first payment."
  },
  "DATE_RANGE": {
    "ALL_TIME": "All time",
    "LAST_YEAR": "Last year",
    "LAST_MONTH": "Last month",
    "LAST_7_DAYS": "Last 7 days",
    "CURRENT_MONTH": "Current month"
  },
  "FILE": {
    "DROP_FILE": "Drop files or",
    "UPLOAD_DOCUMENTS": "Upload documents here",
    "BROWSE": "browse",
    "SUPPORTED_FORMAT": "Supported formate: JPEG, PNG, GIF, MP4, PDF, PSD, AI, Word, PPT",
    "SUPPORTED_FORMAT_PDF": "Supported formate: PDF",
    "TITLE": "File title",
    "TYPE": "Type",
    "ATTACHMENT": "ATTACHMENT",
    "TO_SIGN": "To Sign",
    "DUPLICATE_ERROR_MESSAGE": "File already exists",
    "DOCUMENTS": "Documents",
    "NO_DOCUMENTS": "No documents added yet",
    "RENAME_TITLE": "Rename duplicate file",
    "RENAME_SUBTITLE": "Choose a new name for each duplicate",
    "SIZE_KB": "KB",
    "SIZE_MB": "MB"
  },
  "VALIDATION_MESSAGES": {
    "ONE_RECIPIENT": "Add at least one recipient",
    "ONE_FILE": "Add at least one file",
    "IS_REQUIRED": "is required",
    "CONTRACT_CREATED": "Contract Order Created Successfully",
    "CONTRACT_SIGNED": "Contract Order Signed Successfully",
    "REQUIRED": "This field is required",
    "PHONE_INVALID": "Please enter a valid phone number",
    "NAME_INVALID": "Name is required",
    "EMAIL_INVALID": "Please enter a valid email",
    "EMAIL_REQUIRED": "Email is required",
    "EMAIL_EXISTS": "Email already exists",
    "MINIMUM_AGE": "Your age is {{age}} years, you must be at least {{minAge}} years old",
    "MAXIMUM_AGE": "Your age is {{age}} years, you must be at most {{maxAge}} years old",
    "MINIMUM_LENGTH": "It must be at least {{length}} characters",
    "MAXIMUM_LENGTH": "It must be at most {{length}} characters",
    "PASSWORD_MISMATCH": "Your password does not match",
    "LENGTH_INPUT": "The value you entered is {{length}} characters",
    "NOT_EMPTY": "This field cannot be empty",
    "DUPLICATE_EMAIL": "Duplicate emails are not allowed",
    "DOCUMENT_REQUIRED": "At least 1 document must be provided",
    "INVALID_PHONE_NUMBER": "Invalid phone number",
    "MISSING_DATA": "Please fill out the required fields"
  },
  "ORDER_ACTIVITY": {
    "ORDER_ACTIVITY": "Order Activity",
    "TIME": "Time",
    "RECIPIENT": "Recipient",
    "ACTION": "Action",
    "ACTIVITY": "Activity",
    "STATUS": "Status",
    "DATA_LOADING": "Data Loading",
    "NO_DATA_FOUNDED": "No Data Found"
  },
  "ERRORS": {
    "NOT_FOUND": "Page was not Found",
    "FORBIDDEN": "You do not have permission to access this page",
    "FILE_NOT_SUPPORTED": "File extension is not supported",
    "SERVER_ERROR": "Something went wrong. Please try again.",
    "UNKNOWN_ERROR": "Unknown error occurred, please contact support"
  },
  "LOGIN": {
    "MESSAGE": "Log in to DSS",
    "LOGIN-ERROR": "Login Error Please try again",
    "UNAUTHORIZED": "Unauthorized to sign with this Email",
    "WELCOME_BACK": "Welcome back !",
    "WELCOME": "Welcome",
    "LOGIN_AGAIN": "Please login to gain access the system",
    "TRY_AGAIN": "Please try again"
  },
  "CREATE_CLIENT": {
    "DSS": "DSS",
    "HEADING": "Contract collaboration for every stage of the lifecycle",
    "NOTE": "*Tell us who's your current employer"
  },
  "CREATE_ORGANIZATION": {
    "HEADING": "Lets create your organization",
    "SUBHEADING": "The organization is the container for your orders or documents.",
    "ORGANIZATION_NAME": "Organization name",
    "FORM_EYEBROW": "ORGANIZATION SETUP",
    "FORM_HEADING": "Name your organization",
    "FORM_SUBHEADING": "This is where your team’s documents will live. You’ll invite teammates in the next step.",
    "ORGANIZATION_NAME_PLACEHOLDER": "e.g. JunoSign Inc.",
    "FIELD_HINT": "This name appears on every document and invitation sent from your organization.",
    "NAME_MAX_LENGTH_ERROR": "Organization name cannot exceed 50 characters.",
    "CREATE_ERROR": "Something went wrong while creating your organization. Please try again.",
    "SUBMIT_BUTTON": "Create organization",
    "BACK_LINK": "Back",
    "STEP_BADGE": "Step 3 of 4 - Organization setup",
    "HERO_HEADLINE_1": "One place for",
    "HERO_HEADLINE_2": "every ",
    "HERO_HEADLINE_ITALIC": "signature.",
    "HERO_TEXT_1": "One home for every document, signer and audit trail your team creates. Set it up once.",
    "BENEFIT_1_TITLE": "Legally valid across MENA & Europe",
    "BENEFIT_1_DESC": "eIDAS QES, SOC 2 II, SSL - your signatures hold up where it matters.",
    "BENEFIT_2_TITLE": "Send your first doc in 90 seconds",
    "BENEFIT_2_DESC": "Drag, drop, send. Reusable templates for the contracts you send weekly.",
    "BENEFIT_3_TITLE": "Built for teams, priced fairly",
    "BENEFIT_3_DESC": "Roles, audit logs, SSO. Per-seat billing - no surprise add-ons.",
    "STAT_SIGN_TIME_LABEL": "Avg. sign time",
    "STAT_UPTIME_LABEL": "Uptime SLA",
    "STAT_TEAMS_LABEL": "Active members"
  },
  "INVITE_MEMBERS": {
    "CALLABORATE_WITH_YOUR_TEAM": "Collaborate with your team",
    "INVITE_YOUR_TEAMMATES": "Invite your teammates",
    "ADD_ANOTHER": "Add another",
    "BUTTON_FINISH": "Finish",
    "BUTTON_SKIP": "Skip for now",
    "BUTTON_BACK": "Back",
    "CHARGED_PER_INVITE": "Each team member’s subscription fee will be charged separately after they accept the invitation and log in for the first time.",
    "FORM_EYEBROW": "OPTIONAL - YOU CAN SKIP",
    "FORM_SUBHEADING": "Add teammates to your organization. Each one gets an email invitation to join.",
    "EMAIL_PLACEHOLDER": "name@company.com",
    "BILLING_NOTE": "Each teammate uses one seat, billed monthly. You can add or remove seats anytime in Settings.",
    "SEND_INVITES": "Send invitations",
    "STEP_BADGE": "Step 4 of 4 - Invite team",
    "HERO_HEADLINE_1": "Signing works",
    "HERO_HEADLINE_2": "better",
    "HERO_HEADLINE_3": "as a team.",
    "HERO_TEXT_1": "Add teammates by email and set their role. They can prepare, send and track documents as soon as they accept.",
    "BENEFIT_1_TITLE": "Legally valid across MENA & Europe",
    "BENEFIT_1_DESC": "Signatures hold up under Egypt’s Law No. 15 of 2004, regulated by ITIDA, and across Europe under eIDAS.",
    "BENEFIT_2_TITLE": "Send your first doc in 90 seconds",
    "BENEFIT_2_DESC": "Drag, drop, send. Reusable templates for the contracts you send weekly.",
    "BENEFIT_3_TITLE": "Built for teams, priced fairly",
    "BENEFIT_3_DESC": "Roles, audit logs, SSO. Per-seat billing - no surprise add-ons."
  },
  "PAYMENT": {
    "YEARLY_PLAN": "Yearly Plan",
    "MONTHLY_PLAN": "Monthly Plan",
    "SUBSCRIPTION_MODAL_TITLE": "Choose the right plan for your business",
    "SUBSCRIPTION_MODAL_DESCRIPTION": "Here at JunoSign we focus on markets where technology, innovation, and capital can unlock long-term value and drive economic growth.",
    "MONTHLY": "Monthly",
    "YEARLY": "Yearly",
    "CHOOSE_PLAN": "Choose plan",
    "TERMS_AND_CONDITIONS": "Terms and Conditions",
    "LIMITED_LINKS": "All limited links",
    "ANALYTICS_PLATFORM": "Own analytics platform",
    "CHAT_SUPPORT": "Chat support",
    "OPTIMIZE_HASHTAGS": "Optimize hashtags",
    "UNLIMITED_USERS": "Unlimited users"
  },
  "FORMS": {
    "FORM_INFORMATION": "Form information",
    "TRUCK": "Truck",
    "LICENSE": "License",
    "TRADER_NAME": "Trader name",
    "TRADER_EMAIL": "Trader email",
    "TRADER_PHONE": "Trader phone",
    "FORM_DETAILS": "Form details",
    "ITEMS": "Items",
    "QUANTITY": "Qty",
    "PRICE": "Price",
    "TOTAL": "Total",
    "ITEM_NAME": "Item name",
    "APPLES": "Apples",
    "BANANAS": "Bananas",
    "WATERMELONS": "Watermelons",
    "ORANGES": "Oranges",
    "GRAPES": "Grapes",
    "SUBMIT": "Submit",
    "ITEM_REQUIRED": "Item is required",
    "FORMS": "Forms",
    "CREATE_FORM": "Create a form",
    "FORM_ID": "Form ID",
    "FORM_NAME": "Form name",
    "CREATED_AT": "Created at",
    "LINK": "Link",
    "DELETE": "Delete",
    "LATEST_SUBMISSION": "Latest Submission",
    "FORM_CREATED_SUCCESSFULLY": "Form created successfully",
    "FAILED_TO_CREATE_FORM": "Failed to create form",
    "SETTINGS": {
      "FORM_SETTINGS": "Form settings",
      "SIGNER_SETTINGS": "Signer settings",
      "NOTIFICATIONS": "Notifications",
      "BASIC_INFORMATION": {
        "TITLE": "Basic information",
        "FORM_NAME": "Form name",
        "LANGUAGE": "Language",
        "REPLY_TO_NAME": "Reply to name",
        "REPLY_TO_EMAIL": "Reply to email"
      }
    }
  },
  "ORGANIZATIONS": {
    "SWITCH_ORGANIZATION": "Switch organization",
    "SELECT_WORKSPACE": "Select the workspace to switch to",
    "SWITCH": "Switch",
    "CURRENT": "Current",
    "NEW_ORGANIZATION": "New Organization?",
    "CREATE_NOW": "Create now",
    "MEMBERS": "members"
  },
  "TERMS_AND_CONDITIONS": {
    "FIRST": "Acceptance of Terms",
    "FIRSTDESCRIPTION": " By using DSS, you agree to be bound by these Terms and Conditions. If you do not agree to these Terms and Conditions, please do not use DSS. ",
    "SECOND": "Modification of Terms and Conditions",
    "SECONDDESCRIPTION": " DSS reserves the right to modify, amend, or update these Terms and Conditions at its sole discretion. Any changes to the terms will be effective immediately upon posting the revised version on the DSS website. It is your responsibility to regularly review the terms to stay informed about any modifications. Continued use of DSS after the posting of modifications constitutes your acceptance of the updated Terms and  Conditions. If you do not agree with the modifications, please refrain from using DSS and contact us at [Your Contact Information] with any concerns. ",
    "THIRD": "Services DSS provides",
    "THIRDDESCRIPTION": "An electronic signature solution that allows users to sign and send documents electronically. DSS is a cloud-based service that is accessible from any internet-connected device.",
    "FOURTH": "User Accounts To use DSS",
    "FOURTHDESCRIPTION": "you must create a user account. When you create an account, you will be asked to provide certain information, including your name, email address, and password. You are responsible for maintaining the confidentiality of your account information.",
    "FIFTH": "Use of Services",
    "FIFTHDESCRIPTION": "You may use DSS to sign and send documents for personal or business purposes. You may not use DSS to sign or send documents that are illegal, harmful, or defamatory.",
    "SIXTH": "Intellectual Property DSS and all of its content",
    "SIXTHDESCRIPTION": " Including but not limited to the software, text, images, and graphics, are the property of DSS. You may not copy, modify, distribute, or sell any part of DSS without our written permission.",
    "SEVENTH": " Data Protection",
    "SEVENTHDESCRIPTION": "At DSS safeguarding your data is our paramount commitment. We adhere to stringent privacy standards to ensure the confidentiality and security of your personal information. We unequivocally affirm that we will not, under any circumstances, sell, lease, or otherwise disclose your personal information to third parties without obtaining your explicit and informed consent. Our dedication to your privacy encompasses employing advanced encryption protocols, implementing secure data storage practices, and continuously monitoring and enhancing our security measures to mitigate potential risks. We recognize the sensitivity of the information you entrust to us and are unwavering in our pledge to treat it with the utmost care and diligence.Should there be any proposed changes to our data protection practices, we will promptly notify you, seeking your consent where required by applicable laws and regulations. For a comprehensive understanding of our data protection policies, please refer to our Privacy Policy, which outlines in detail how we collect, process and protect your personal information.",
    "EIGHTH": " Data Protection",
    "EIGHTHDESCRIPTION": "DSS shall not be held liable for any damages, including, but not limited to, lost profits,  data loss, or business interruption arising from the use or inability to use DSS. Users acknowledge that DSS is provided as-is and while diligent efforts are made to ensure its functionality and reliability, unforeseen circumstances or technical issues may occur. In no event shall DSS, its affiliates, or its licensors be liable for any direct, indirect, incidental, special, or consequential damages, whether based on warranty, contract, tort, or any other legal theory, arising out of the use or performance of DSS. Users are encouraged to regularly backup critical data and assess the compatibility of DSS with their specific requirements. DSS disclaims any warranties or representations regarding the accuracy, completeness, or reliability of the software.By using DSS, users accept and acknowledge this limitation of liability, and it is recommended to review theseterms periodically for awareness and understanding",
    "NINTH": " Governing Law",
    "NINTHDESCRIPTION": " These Terms and Conditions will be governed by and construed in accordance with the applicable laws of the jurisdiction where the user is located or, if not specified, in accordance with the laws chosen by the parties to govern the use of this e-signature solution called DSS. The parties hereby agree to submit to the exclusive jurisdiction of the competent courts in the relevant jurisdiction for the resolution of any disputes arising under or in connection with these Terms and Conditions.",
    "TENTH": "Entire Agreement",
    "TENTHDESCRIPTION": "These Terms and Conditions constitute the entire agreement between you and DSS and supersede all prior agreements and understandings between the parties.",
    "ELEVENTH": " Subscription Payments and Refunds",
    "ELEVENTHDESCRIPTION": "Upon making a subscription payment for DSS, you acknowledge and agree that the subscription fees are non-refundable. No refunds will be provided until the subscription duration ends. It is your responsibility to evaluate and ensure the compatibility of DSS with your requirements before committing to a subscription. If you have any questions or concerns regarding the subscription terms, please contact us at [Your Contact Information] before making a payment. Severability If any provision of these Terms and Conditions is held to be unenforceable such provision will be struck from these Terms and Conditions and the remaining provisions will remain in full force and effect.",
    "TWELFTH": "No waiver of any provision",
    "TWELFTHDESCRIPTION": " in these Terms and Conditions shall be valid unless it is documented in writing and duly  signed by both parties to be considered effective.",
    "THIRTEEN": "Contact Information",
    "THIRTEENDESCRIPTION": "If you have any questions about these Terms and Conditions, please contact us at [Your Contact Information].",
    "AGREE_TERMS_AND_CONDITIONS": "By ticking, you are confirming that you have read, understood and agree to the DSS terms and conditions.",
    "PROCEED": "Confirm & Proceed"
  },
  "FORM_BUILDER": {
    "NAME": "Form builder",
    "NEW_FORM": "New form",
    "SIGNER": "Signer",
    "TEXTAREA": "Text area",
    "FORM_ELEMENTS": "Form elements",
    "PRIMARY_SIGNER": "Primary signer",
    "GROUP_TITLE": "Group title"
  },
  "facebook": "Continue with Facebook",
  "NO-RESULTS": "No results found",
  "NO-RESULTS-DESCRIPTION": "No results match your search. Try adjusting your search terms or clearing any active filters.",
  "NO-ORDERS": "No signing orders yet",
  "NO-ORDERS-DESCRIPTION": "Create your first signing order to get started. Share documents with recipients and track their signing progress.",
  "CONTRACT_SIGNED": "Contract Order Signed Successfully",
  "CONTRACT_REVIEWED": "Contract Order Reviewed Successfully",
  "SERVICE_IN_MAINTENANCE": "Service in maintenance",
  "SIGNING_HEADER": {
    "SIGNATURE_REQUESTED": "Signature requested"
  },
  "SIGNING_PARTICIPANT": {
    "DELETE_RECIPIENT_TITLE": "Delete recipient",
    "DELETE_RECEIVER_TITLE": "Delete receiver",
    "REMOVE_RECIPIENT": "Delete recipient",
    "REMOVE_RECEIVER": "Delete receiver",
    "DELETE_RECIPIENT_DESCRIPTION": "This will permanently remove the recipient from the signing order. Any fields assigned to them will become unassigned.",
    "DELETE_RECEIVER_DESCRIPTION": "This will permanently remove the receiver from the signing order. Any fields assigned to them will become unassigned.",
    "SEND_REMINDER_TITLE": "Send a Reminder",
    "SEND_REMINDER_SUBTITLE": "Select recipients to notify",
    "SELECTED_COUNT": "{{count}} selected",
    "DELETE_SUBTITLE": "This action cannot be undone."
  },
  "DOCUMENT_PREVIEW": {
    "DECLINE_ORDER_TITLE": "Decline signing order",
    "DECLINE_ORDER_SUBTITLE": "This action cannot be undone.",
    "DECLINE_ORDER_CONFIRM": "Yes, I’m sure",
    "DECLINE_MODAL_TITLE": "Reject this order",
    "DECLINE_MODAL_SUBTITLE": "This action cannot be undone",
    "DECLINE_MODAL_CANCEL": "Cancel",
    "DECLINE_MODAL_CONFIRM": "Reject Order",
    "DECLINE_CONFIRMATION": "Are you sure you want to reject this signing order? This will notify all signers and permanently cancel the request.",
    "DECLINE": "Reject order",
    "APPROVE": "Approve/Sign Order",
    "REVIEWED": "Mark order as reviewed",
    "REFRESH": "Refresh Page",
    "SOMETHING_WENT_WRONG": "Something went wrong. Please try again later!",
    "NOT_FOUND": "Unable to get your document please contact support",
    "SUPPORT": "Your web browser doesn't support file rendering",
    "DOWNLOAD": "Download file",
    "CONFIRMATION_MESSAGE": "I confirm that I have read and understood all the documents.",
    "MODAL_CONFIRMATION_MESSAGE": "Please confirm that you have read and understood all the provided documents",
    "USER_AGREEMENT": "User Agreement",
    "AGREE_SIGN": "Agree & Sign",
    "INVALID_EMAIL": "This document is assigned to a different email address",
    "WRONG_EMAIL_EXPLANATION": "You are signed in with an email that does not match the recipient invited to sign this document.",
    "HIDE_MY_EMAIL_NOT_ALLOWED": "Hidden email detected - Apple's hidden email isn't accepted. Click <a href=\"https://support.apple.com/en-eg/guide/icloud/mm3adb030cbf/icloud\" target=\"_blank\" class=\"underline\">more info</a>",
    "STEP_VERIFY": "Verify",
    "STEP_REVIEW": "Review",
    "STEP_SIGN": "Sign",
    "STEP_DONE": "Done",
    "REVIEW_TITLE": "Review your documents",
    "REVIEW_SUBTITLE": "Read all documents carefully before proceeding to sign. You must acknowledge that you have reviewed them.",
    "REQUEST_DETAILS_LABEL": "Request Details",
    "YOU": "you",
    "SIGNER_LABEL": "Signer",
    "SENDER_LABEL": "Sender",
    "ORGANIZATION_LABEL": "Organization",
    "EXPIRES_LABEL": "Expires",
    "DOCUMENTS_LABEL": "Documents to sign",
    "PREVIEW_BUTTON": "Preview",
    "INFO_NOTE": "Please review all attached documents in their entirety. By signing, you confirm that you have read, understood, and agree to all terms outlined herein.",
    "CONTINUE_TO_SIGN": "Continue to sign",
    "SCROLL_TO_UNLOCK": "Preview all documents to continue",
    "PAGE_COUNT": "{{count}} pages",
    "LOADING_DOCUMENT": "Loading document..."
  },
  "SIGN_IN": {
    "MESSAGE": "Log in to DSS",
    "HEADING": "Contract collaboration for every stage of the lifecycle",
    "SOMETHING_WENT_WRONG": "Something went wrong. Please try again later!",
    "LOGOUT_AND_RETRY": "Try again",
    "SIGN_HEADING": "Sign your order",
    "SIGN_SUBHEADING": "Verify your identity to review and sign the order sent to you.",
    "CONTINUE_WITH": "Continue with {{provider}}",
    "METHOD_GOOGLE_DESCRIPTION": "Sign with your Google account",
    "METHOD_APPLE_DESCRIPTION": "Sign with your Apple ID",
    "METHOD_LINKEDIN_DESCRIPTION": "Sign with your LinkedIn account",
    "METHOD_DOODLE_DESCRIPTION": "Receive a one-time code by email",
    "METHOD_TYPED_DESCRIPTION": "Type your name. Pick a style."
  },
  "ORDER_RECEIPT": {
    "ORDER_DECLINED": "Order declined",
    "ORDER_DECLINED_SUCCESSFULLY": "You’ve declined the order, You can dismiss this window",
    "ORDER_DECLINED_FAILED": "Failed to decline the order",
    "SIGNED_SUCCESSFULLY": "Order signed successfully",
    "REVIEWED_SUCCESSFULLY": "Order reviewed successfully",
    "SIGNER_NAME": "Signer name",
    "REVIEWER_NAME": "Reviewer name",
    "ORDER_ID": "Order ID #",
    "SIGNED_BY": "Signed by",
    "REVIEWED_BY": "Reviewed by",
    "SIGNED_ON": "Signed on",
    "REVIEWED_ON": "Reviewed on",
    "HELP": " We’re here to help! For support or any questions, reach out to us at",
    "SIGNATURE_REQUESTED": "Signature requested",
    "SIGNING_REJECTED": "Signing rejected",
    "ORDER_SIGNED": "Order signed!",
    "ORDER_REVIEWED": "Order reviewed!",
    "ORDER_REJECTED": "Order rejected!",
    "ORDER_SIGNED_SUBTITLE": "Your signature has been recorded and is legally binding.",
    "ORDER_REVIEWED_SUBTITLE": "Your review has been recorded and is legally binding.",
    "ORDER_DECLINED_SUBTITLE": "You have rejected this signing order.",
    "ORDER_DECLINED_BY_RECIPIENT_SUBTITLE": "This order was declined by one of the recipients.",
    "CARD_TITLE_SIGNED": "Order signed",
    "CARD_TITLE_REVIEWED": "Order reviewed",
    "CARD_TITLE_REJECTED": "Order rejected",
    "STATUS_SIGNED": "Signed",
    "STATUS_REVIEWED": "Reviewed",
    "STATUS_REJECTED": "Rejected",
    "STATUS_PENDING": "Pending",
    "REJECTED_ON": "Rejected on",
    "ALL_RECIPIENT_STATUS": "All recipient status",
    "YOU": "You",
    "EMAIL_PENDING_NOTE": "You will receive an email with the signed copy once all pending recipient are completed.",
    "ORDER_CANCELLED": "Order cancelled!",
    "ORDER_CANCELLED_SUBTITLE": "This order has been cancelled by the sender.",
    "ORDER_CANCELLED_BADGE": "Order cancelled",
    "CANCELLED_ON": "Cancelled on",
    "ORDER_EXPIRED": "Order expired!",
    "ORDER_EXPIRED_SUBTITLE": "This order has expired and is no longer accepting signatures.",
    "ORDER_EXPIRED_BADGE": "Order expired",
    "EXPIRED_ON": "Expired on",
    "ORDER_PENDING": "Signature pending",
    "ORDER_PENDING_SUBTITLE": "This order is awaiting your action.",
    "REQUESTED_ON": "Requested on"
  },
  "404": {
    "MESSAGE": "Uh-oh! Page Vanished into the Digital Unknown",
    "DESCRIPTION": "The page you are looking for might have been removed, had its name changed, or is temporarily unavailable."
  },
  "ORDER_NOT_FOUND": {
    "MESSAGE": "Order Not Found: The Digital Trail Leads to an Empty Cart",
    "DESCRIPTION": "The order you requested does not exist. It may have been deleted or expired. Please verify the order details and try again"
  },
  "DRAW_SIGNATURE": {
    "MESSAGE": "Draw your signature below",
    "CLEAR": "Clear",
    "NEED_DRAW": "You need to draw a signature",
    "SIGN_DOCUMENT": "Sign Document",
    "TITLE": "Draw your signature",
    "SUBTITLE": "Sign in the box below using your mouse or finger. This will be applied to all documents in this request.",
    "CANVAS_LABEL": "Sign here",
    "CANVAS_PLACEHOLDER": "Sign with your finger or mouse",
    "HINT": "Use mouse or touch to draw",
    "APPLY_SUBMIT": "Apply Signature & Submit",
    "BACK": "Back",
    "REJECT_ORDER": "Reject order"
  },
  "TYPE_SIGNATURE": {
    "BACK": "Back",
    "TITLE": "Type your signature",
    "SUBTITLE": "Type your legal name. JunoSign will automatically format it into your preferred professional signature style.",
    "LANGUAGE_LABEL": "Signature language",
    "LANGUAGE_HINT": "Select your preferred signature language.",
    "SCRIPT_LATIN": "Latin",
    "SCRIPT_ARABIC": "Arabic",
    "PREVIEW_LABEL": "Signature preview",
    "PREVIEW_HINT": "Preview your professional signature appearance.",
    "STYLE_LABEL": "Signature style",
    "STYLE_1": "Style 1",
    "STYLE_2": "Style 2",
    "STYLE_3": "Style 3",
    "STYLE_4": "Style 4",
    "LEGAL_NAME_LABEL": "Legal name",
    "LEGAL_NAME_PLACEHOLDER": "Enter your full legal name",
    "PREVIEW_PLACEHOLDER_LATIN": "Your signature",
    "PREVIEW_PLACEHOLDER_ARABIC": "توقيعك",
    "APPLY_SUBMIT": "Apply Signature & Submit",
    "REJECT_ORDER": "Reject order",
    "ERRORS": {
      "MAX_LENGTH": "Name must be 15 characters or fewer",
      "LATIN_ONLY": "Use Latin letters only, or switch the signature language to Arabic",
      "ARABIC_ONLY": "Use Arabic letters only, or switch the signature language to Latin"
    }
  },
  "CONFIRM_SIGNATURE": {
    "BACK": "Back",
    "TITLE": "Confirm your signature",
    "SUBTITLE": "Review your verified identity below. This will be applied to all documents in this request.",
    "YOUR_DIGITAL_SIGNATURE": "Your digital signature",
    "INFO_NOTE": "By applying your signature, you confirm that you have read, understood, and agree to all terms outlined in the documents.",
    "APPLY_SUBMIT": "Apply Signature & Submit",
    "SUBMIT_REVIEW": "Mark order as reviewed",
    "REJECT_ORDER": "Reject order",
    "SIGN_FAILED": "Failed to sign the order. Please try again."
  },
  "USER_ROLES": {
    "VIEWER": "Viewer",
    "USER": "User",
    "TEAM_LEAD": "Team lead",
    "ADMIN": "Admin",
    "OWNER": "Owner"
  },
  "REMINDER_INTERVAL": {
    "NEVER": "Never",
    "DAILY": "Daily",
    "TWICEAWEEK": "Twice a week",
    "WEEKLY": "Weekly",
    "ADAYBEFOREEXPIRATION": "A day before expiration"
  },
  "VERIFICATION_METHOD": {
    "EMAIL": "Email",
    "WHATSAPP_AND_EMAIL": "WhatsApp/Email",
    "WHATSAPP": "WhatsApp"
  },
  "FLOATING_DOC_LAYOUT": {
    "DOC_1_TITLE": "Service Agreement",
    "DOC_1_META": "Ref · 24-A8F",
    "DOC_1_STATUS": "Signed in 47s",
    "DOC_2_TITLE": "Cooperation Terms — Private Company",
    "DOC_2_META": "Page 2 of 2 · 1 Signature field",
    "DOC_3_TITLE": "NDA — Private Company",
    "DOC_3_META": "Confidential",
    "SIGN_HERE": "Sign here",
    "BADGE_TEXT": "Signature requested"
  },
  "SNACKBAR": {
    "SUCCESS": "Success",
    "ERROR": "Error",
    "INFO": "Information",
    "WARNING": "Warning",
    "AND_MORE": "and {{ count }} more"
  },
  "TABLE": {
    "NO_DATA": "No data to display",
    "ACTIONS": "Row actions",
    "SELECT_PAGE": "Select all rows on this page",
    "SELECT_ROW": "Select row",
    "EXPAND_ROW": "Expand row",
    "COLLAPSE_ROW": "Collapse row"
  }
}
